import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Build from "@/pages/Build";
import Work from "@/pages/Work";
import Apply from "@/pages/Apply";
import Book from "@/pages/Book";

export default function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/build" element={<Build />} />
          <Route path="/work" element={<Work />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/book" element={<Book />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
